(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-blp-filter-form]');
    if (form && event.target.type === 'checkbox') {
      form.submit();
    }

    var sortForm = event.target.closest('[data-blp-sort-form]');
    if (sortForm && event.target.name === 'sort_by') {
      sortForm.submit();
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-blp-event]');
    if (!target) return;

    var detail = {
      event: target.getAttribute('data-blp-event'),
      destination: target.getAttribute('href') || ''
    };

    document.dispatchEvent(new CustomEvent('blacklist:conversion', { detail: detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'blacklist_conversion', conversion_type: detail.event });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var honeypot = form.querySelector('[data-blp-honeypot]');
    if (honeypot && honeypot.value.trim() !== '') {
      event.preventDefault();
      return;
    }

    if (form.querySelector('[data-blp-inquiry-submit]')) {
      document.dispatchEvent(new CustomEvent('blacklist:conversion', {
        detail: { event: 'dyno-inquiry-submit' }
      }));
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'blacklist_conversion', conversion_type: 'dyno-inquiry-submit' });
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var message = document.querySelector('[data-blp-form-success], [data-blp-form-errors]');
    if (message) message.focus();

    document.querySelectorAll('[data-blp-catalog]').forEach(function (section) {
      var rail = section.querySelector('[data-blp-catalog-rail]');
      var controls = section.querySelector('[data-blp-catalog-controls]');

      if (rail && controls) {
        var previousButton = controls.querySelector('[data-blp-catalog-scroll="previous"]');
        var nextButton = controls.querySelector('[data-blp-catalog-scroll="next"]');

        var updateCatalogControls = function () {
          var hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
          controls.hidden = !hasOverflow;
          previousButton.disabled = !hasOverflow || rail.scrollLeft <= 2;
          nextButton.disabled = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };

        var moveCatalogRail = function (direction) {
          var distance = Math.max(rail.clientWidth * 0.76, 180) * direction;
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (typeof rail.scrollBy === 'function') {
            rail.scrollBy({ left: distance, behavior: reducedMotion ? 'auto' : 'smooth' });
          } else {
            rail.scrollLeft += distance;
          }
        };

        previousButton.addEventListener('click', function () { moveCatalogRail(-1); });
        nextButton.addEventListener('click', function () { moveCatalogRail(1); });
        rail.addEventListener('scroll', updateCatalogControls, { passive: true });
        window.addEventListener('resize', updateCatalogControls);
        updateCatalogControls();
      }

      section.querySelectorAll('[data-blp-category-tags]').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;

          section.querySelectorAll('[data-blp-category-tags][open]').forEach(function (openDetails) {
            if (openDetails !== details) openDetails.open = false;
          });
        });
      });
    });

    var categorySearchHeading = document.querySelector('[data-blp-category-search-heading]');
    if (categorySearchHeading) {
      var categoryName = new URL(window.location.href).searchParams.get('category');
      if (categoryName) categorySearchHeading.textContent = categoryName;
    }

    if (document.querySelector('[data-blp-form-success]')) {
      document.dispatchEvent(new CustomEvent('blacklist:conversion', {
        detail: { event: 'dyno-inquiry-success' }
      }));
    }
  });

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-blp-current-availability]').forEach(function (element) {
      element.textContent = variant.available ? 'Available' : 'Unavailable';
    });
    document.querySelectorAll('[data-blp-current-sku]').forEach(function (element) {
      element.textContent = variant.sku || 'Not provided';
    });
    document.querySelectorAll('[data-blp-current-variant]').forEach(function (element) {
      element.textContent = variant.public_title || variant.title || 'Selected';
    });
    document.querySelectorAll('[data-blp-event="product-installation-quote"]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variant.id);
      link.href = url.toString();
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-blp-deferred-video] .blp-deferred-video__trigger');
    if (!trigger) return;

    var container = trigger.closest('[data-blp-deferred-video]');
    var iframe = document.createElement('iframe');
    iframe.src = container.getAttribute('data-video-src');
    iframe.title = container.getAttribute('data-video-title') || 'Video';
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    container.replaceChildren(iframe);
  });
}());
